import { Society } from 'types';
import { isPlatformAXA } from 'utils/showDetails';

import { emailContentTypes } from 'modules/communications/constants/emailContetTypes';
import { AXA_DIVIDEND_BOUNCE_ALLOWED_EMAILS } from '../constants/axaDividendBounceAllowedEmails';
import { isAxaDividendBounceRetryActive } from './isAxaDividendBounceRetryActive';
import { getCommunication } from './getCommunication';
import { getTemplate } from './getTemplate';

type Props = {
  subject: string;
  actualSociety: Society;
  userId: string;
  operationId: string;
};

export const getEmailData = ({
  subject,
  actualSociety,
  userId,
  operationId,
}: Props) => {
  const societyLanguage = actualSociety?.societyLanguage || 'es';
  const template = getTemplate(societyLanguage);

  const emailData: Record<string, unknown> = {
    subject,
    template,
    operationId,
    templateData: [
      {
        name: 'societyName',
        content: actualSociety?.name,
      },
    ],
    user: userId,
    society: actualSociety?._id,
    date: new Date(),
    status: 'SENT',
  };

  if (isPlatformAXA) {
    emailData.contentType = emailContentTypes.DIVIDENDS;
  }

  if (!isPlatformAXA) {
    emailData.templateBody = getCommunication(actualSociety);
  }

  if (isAxaDividendBounceRetryActive(operationId)) {
    emailData.allowedRecipientEmails = AXA_DIVIDEND_BOUNCE_ALLOWED_EMAILS;
    emailData.allowedRecipientEmailsOperationId = operationId;
  }

  return emailData;
};
